// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'

import VueMaterial from 'vue-material'
import VeeValidate from 'vee-validate'

import MaterialInput from './components/Material/MaterialInput.vue'
import MaterialInputDual from './components/Material/MaterialInputDual.vue'
import MaterialSelect from './components/Material/MaterialSelect.vue'

Vue.use(VueMaterial)
Vue.use(VeeValidate)

Vue.component('material-input', MaterialInput)
Vue.component('material-inputDual', MaterialInputDual)
Vue.component('material-select', MaterialSelect)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  store,
  template: '<App/>',
})



// WEBPACK FOOTER //
// ./src/main.js